export class NotificationAppConfig {
    apiEndpoint: string;
    apiTimeout: number;
    apiRetry: number;
    runmode: string;
    permissionCode: { [key: string]: string };
    group: { [key: string]: string };
    application: { [key: string]: string };
}
  
export class NotificationConfig {
    config: { [key: string]: string };
}
